import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';

export default function Timeline_item_events(props) {
  const getFormattedDateTime = (dateTimeString) => {
    // Implement your datetime formatting logic here
    return dateTimeString;
  };
  
  return (<div
              key={props.index}
              style={{
                display: 'flex',
                marginBottom: '20px',
                alignItems: 'center',
                position: 'relative',
              }}
            >
              <div style={{ marginRight: '20px' }}>{props.icon}</div>
              <div style={{ flexGrow: 1, position:'relative', width:'100px' }}>
                <div><Typography variant="caption"style={{ fontWeight: 'bold', marginBottom: '4px' }}>{props.title}</Typography></div>
                <div><Typography variant="caption" color="textSecondary">Date: {getFormattedDateTime(getDateTimeHere(props.date_time)).split(' ')[0]}</Typography></div>
                <div><Typography variant="caption" color="textSecondary">Time: {getFormattedDateTime(getDateTimeHere(props.date_time)).split(' ')[1]}</Typography></div>
                {props.extra_content}
              </div>
            </div>
          );
}
